export default "__VITE_ASSET__BsAY86n8__"